import { useState } from 'react';
import { useQuery } from 'react-query';
import { useInitialCampaign } from 'modules/campaigns/modules/creative-creator/components/CampaignsField/hooks/useInitialCampaign';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import useFormFieldValue from 'modules/taboola-common-frontend-modules/formData/hooks/useFormFieldValue';
import { useTrackingApi } from 'services/api';
import { useGetPixelTesterUrl } from '../../../hooks/useGetPixelTesterUrl';

export const useS2STestLinkGenerator = () => {
    const { formAccount } = useFormDataContext();
    const { accountId } = formAccount;

    const initialCampaign = useInitialCampaign();
    const getPixelTesterUrl = useGetPixelTesterUrl();
    const { generateTestLink } = useTrackingApi();

    const [pixelTesterUrl, setPixelTesterUrl] = useState(null);
    const { onChange: onChangeCampaign, value: selectedCampaign } = useFormFieldValue(
        { field: 'campaign' },
        { initialCampaign, formAccount }
    );

    const { refetch, data } = useQuery(
        ['s2sGenerateTestLink', accountId, selectedCampaign?.value],
        () => generateTestLink(accountId, selectedCampaign?.value),
        {
            onSuccess: () => {},
            cacheTime: 0,
            refetchOnWindowFocus: false,
            enabled: false,
        }
    );

    const handleGenerateClick = async () => {
        const result = await refetch();
        const rawUrl = result?.data?.url?.trim();

        if (rawUrl) {
            const urlWithTblci = await getPixelTesterUrl(rawUrl);
            setPixelTesterUrl(urlWithTblci);
        }
    };

    const handleCampaignChange = campaign => {
        onChangeCampaign(campaign);
        setPixelTesterUrl(null);
    };

    return {
        formAccount,
        selectedCampaign,
        data,
        pixelTesterUrl,
        handleGenerateClick,
        handleCampaignChange,
    };
};
